
import { Component, Vue } from 'nuxt-property-decorator'

import AppLayout from '~/components/AppLayout.vue'
import AppHeader from '~/components/AppHeader'
import AppOfflineBar from '~/components/AppOfflineBar.vue'
import AppFooter from '~/components/AppFooter.vue'
import AppLayoutOverlay from '~/components/AppLayoutOverlay/AppLayoutOverlay.vue'
import CookieBanner from '~/components/CookieBanner.vue'

@Component({
  components: {
    CookieBanner,
    AppLayoutOverlay,
    AppLayout,
    AppHeader,
    AppFooter,
    AppOfflineBar,
  },
})
export default class DefaultLayout extends Vue {
  get headerType () {
    return this.localePath('black-april') === this.$route.path ? 'navigation-less' : 'default'
  }

  get headerTheme () {
    return this.localePath('black-april') === this.$route.path ? 'dark' : 'light'
  }

  get headerLogoPosition () {
    return this.localePath('black-april') === this.$route.path ? 'center' : 'left'
  }

  get isHeaderWithShadow () {
    return this.localePath('index') !== this.$route.path
  }

  get keepAliveKey () {
    return this.$route.fullPath
  }

  created () {
    if (process.client) {
      this.$analytics.emarsys.init()
    }
  }
}
